import React, {useCallback, useState} from 'react';
import AuthActions from 'actions/AuthActions';
import LoginInputLabel from '@components/input-label/LoginInputLabel';
import LoginTextField from '@components/text-field/LoginTextField';
import Button from '@material-ui/core/Button';
import {LoginTypeResponse} from 'stores/AuthSource';
import {makeStyles} from '@material-ui/core/styles';
import {EMAIL_REGEX} from 'utils/regexValidators';

export interface LoginTypeStepProps {
  setUsername: React.Dispatch<React.SetStateAction<string>>;
  setLoginTypeResponse: React.Dispatch<React.SetStateAction<LoginTypeResponse | null>>;
}

export const LoginTypeStep: React.FC<LoginTypeStepProps> = props => {
  const [username, setUsername] = useState('');
  const [disableButton, setDisableButton] = useState(false);

  const findLoginType = useCallback(
    e => {
      e.preventDefault();
      if (EMAIL_REGEX.test(username)) {
        setDisableButton(true);
        AuthActions.findLoginType({
          email: username,
        }).then(loginTypeResponse => {
          props.setLoginTypeResponse(loginTypeResponse);
        });
      }
    },
    [props, username]
  );

  const css = useStyles();

  return (
    <div className={css.parent}>
      <h3 className={css.header}>Enter your email to get started</h3>
      <form onSubmit={findLoginType}>
        <LoginInputLabel htmlFor="login-username" className={css.emailLabel}>
          Email
        </LoginInputLabel>
        <LoginTextField
          name="username"
          id="login-username"
          className={css.emailField}
          onChange={e => {
            const username = e.target.value;
            props.setUsername(username);
            setUsername(username);
          }}
          autoFocus={true}
        />
        <div className={css.nextButtonParent}>
          <Button
            name="next"
            size="large"
            color="primary"
            type="submit"
            variant="contained"
            className={css.nextButton}
            disabled={disableButton}>
            Next →
          </Button>
        </div>
      </form>
    </div>
  );
};

const useStyles = makeStyles(() => {
  return {
    parent: {
      margin: 'auto',
      width: '75%',
    },
    header: {
      marginBottom: '1rem',
      fontWeight: 500,
    },
    emailLabel: {
      fontWeight: 'normal',
    },
    emailField: {
      width: '100%',
    },
    nextButtonParent: {
      display: 'flex',
      justifyContent: 'right',
    },
    nextButton: {
      margin: '1rem 0',
      fontWeight: 'normal',
    },
  };
});
